import React from 'react';
import styled from 'styled-components';
import { attachCategorySlug, attachSubcategorySlug, trackAnalytics, attachLocale } from '../../../../lib/utils';
import CanadaFlag from '../../../svgs/CanadaFlag';
import UsaFlag from '../../../svgs/UsaFlag';
import {
  USD,
  DOM_SHOP_DETAILS,
} from '../../../../lib/constants';

const ShopDetailsDiv = styled.div`
  padding-top: ${p => p.isMobile ? p.theme.unit(1) : p.theme.unit(5)};
  ${p => p.isMobile && `padding-bottom: ${p.theme.unit(4)}`};
  width: ${p => p.theme.unit(33)};
  min-height: ${p => p.theme.unit(35)};
`;

const FlagDiv = styled.div`
  max-width: ${p => p.theme.unit(6.25)};
  max-height: ${p => p.theme.unit(3.125)};
  padding-right: ${p => p.theme.unit(1)};
`;

const CurrencyDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-bottom: ${p => p.theme.unit(3)};
`;

const DetailsTitleDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading.md}
  color: ${p => p.theme.c.text.primary};
  padding-bottom: ${p => p.theme.unit(1)};
`;

const DeliveryInformationDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  padding-bottom: ${p => p.theme.unit(3)};
`;

const CategoryBrickAnchor = styled.a`
  cursor: pointer;
  text-decoration: none;

  display: inline-block;
  margin-top: ${p => p.theme.unit(1)};
  margin-right: ${p => p.theme.unit(1)};

  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${(p) => p.theme.c.button.light.secondary.text.default};
  border: 1px solid ${(p) => p.theme.c.button.light.secondary.border.default};
  padding: ${p => p.theme.unit(0.5)} ${(p) => p.theme.unit(1)};

  :hover {
    background-color: ${(p) => p.theme.c.button.light.secondary.background.hover};
    color: ${(p) => p.theme.c.button.light.secondary.text.hover};
  }
`;

const CategoryBrick = (props) => {
  const {
    category = {},
    locale,
    slugToUse,
    categorySlug = '',
    subCategory = false,
  } = props;

  const {
    name = '',
    tags = {},
  } = category;

  // attach locale to parent category or filtered subcategory url
  let resolvedSlug = subCategory
    ? attachSubcategorySlug(slugToUse, categorySlug)
    : attachCategorySlug(slugToUse);
  resolvedSlug = attachLocale(resolvedSlug, locale);
  const trackingComponent = subCategory ? `${slugToUse}-${categorySlug}` : slugToUse;
  const track = trackAnalytics(DOM_SHOP_DETAILS, trackingComponent, resolvedSlug, tags);

  const {
    url,
    dataTrackingId,
    dataTrack,
  } = track;

  return (
    <CategoryBrickAnchor
      id={dataTrackingId}
      data-track-id={dataTrackingId}
      data-track-click={dataTrack}
      href={url}
    >
      {name}
    </CategoryBrickAnchor>
  );
};

const ShopDetails = (props) => {
  const {
    shopCurrencyTitle = 'Currency',
    currency = 'CAD',
    shopDeliveryTitle = '',
    deliveryInformation = '',
    shopCategoriesTitle = '',
    categories = [],
    locale = 'en',
    parentCategories = [],
    subCategories = [],
    isMobile = false,
  } = props;

  const FlagToUse = (currency === USD) ? UsaFlag : CanadaFlag;
  const CategoriesComp = categories.map((category, index) => {
    let slugToUse;
    let subCategory = false;
    // If category slug not in subCategory slugs array it is a
    // parentCategory and we pass down category slug
    if (!subCategories.includes(category.slug)) {
      slugToUse = category.slug;
    } else {
    // If category slug is in subCategory slugs array we iterage through
    // parenteCategories array to find category slugs parentCategory
      const filteredParentCategories = parentCategories.filter(parentCategory =>
        parentCategory.subCategories && parentCategory.subCategories.includes(category.slug));
      slugToUse = filteredParentCategories[0]?.slug || category.slug;
      subCategory = true;
    }
    return (
      <CategoryBrick
        key={`${category.name}-${index}`}
        category={category}
        categorySlug={category.slug}
        subCategory={subCategory}
        slugToUse={slugToUse}
        locale={locale} />
    );
  });

  const compToRender = (
    <ShopDetailsDiv isMobile={isMobile}>
      {/* Currency */}
      <DetailsTitleDiv>{shopCurrencyTitle}</DetailsTitleDiv>
      <CurrencyDiv>
        <FlagDiv>
          <FlagToUse />
        </FlagDiv>
        {currency}
      </CurrencyDiv>

      {/* Delivery */}
      <DetailsTitleDiv>{shopDeliveryTitle}</DetailsTitleDiv>
      <DeliveryInformationDiv>
        {deliveryInformation}
      </DeliveryInformationDiv>

      {/* Categories */}
      <DetailsTitleDiv>{shopCategoriesTitle}</DetailsTitleDiv>
      <div>
        {CategoriesComp}
      </div>
    </ShopDetailsDiv>
  );

  return compToRender;
};

export default ShopDetails;
